import { Controller } from "@hotwired/stimulus"
import Chartkick from 'chartkick'
import { draw } from 'patternomaly'
import { clickToOpenURL, configureDataLabels, configureGroupStackDataLabels, getStackPattern } from '../utils/charts.js'

function getDatasetColor(name) {
  switch (name) { 
    case 'Too much':
      return '#FFCBBC';
    case 'Full':
      return '#FD8C76';
    case 'OK':
      return '#E9573E';
    case 'Low':
      return '#9D0B00';
    case 'Empty':
      return '#500000';
    default:
      return '#DCD9E8';
  }
}

function getDatasetOrder(name) {
  switch (name) {
    case 'Too much':
      return 4;
    case 'Full':
      return 3;
    case 'OK':
      return 2;
    case 'Low':
      return 1;
    case 'Empty':
      return 0;
    default:
      return 5;
  }
}



function getDatasetLabel(name) {
  switch (name) {
    case 'unconfortable':
      return 'Uncomfortable';
    case 'neutral':
      return 'Neutral';
    case 'confortable':
      return 'Comfortable';
    default:
      return name;
  }
}

export default class extends Controller{
  static targets = ["link"]
  static values = { mode: String }

  connect() {
    const _this = this
    _this.stacks = []
    const _linkTarget = this.linkTarget
    setTimeout(function(){
      const chart = Chartkick.charts.energylevelschart
      let chartConfig = chart.getChartObject().config
      chartConfig.options.layout = { padding: { left: 10, right: 10, top: 20, bottom: 20 } }
      chartConfig.options.interaction.mode = 'nearest'
      chartConfig.options.plugins.tooltip = {
        callbacks: {
          label: (tooltipItem) => {
            const data = tooltipItem.chart.data;
            const datasetIndex = tooltipItem.datasetIndex;
            const index = tooltipItem.dataIndex;
            const datasetLabel = data.datasets[datasetIndex].label || "";
            // You can use two type values.
            // `data.originalData` is raw values,
            // `data.calculatedData` is percentage values, e.g. 20.5 (The total value is 100.0)
            const originalValue = data.originalData[datasetIndex][index];
            const rateValue = data.calculatedData[datasetIndex][index];
            return `${datasetLabel}: ${rateValue}% (${originalValue} students)`;
          }
        }
      }
      chart.getChartObject().data.datasets.forEach((dataset) => { 
        const color = getDatasetColor(dataset.label)
        if (_this.modeValue === 'grouped') {
          const pattern = getStackPattern(dataset.stack, _this.stacks)
          dataset.backgroundColor = draw(pattern, color);
          dataset.borderColor = draw(pattern, color)
        } else {
          dataset.backgroundColor = color;
          dataset.borderColor = color
        }
        dataset.order = getDatasetOrder(dataset.label)
        dataset.label = _this.modeValue === 'grouped' ? `${dataset.stack}: ${getDatasetLabel(dataset.label)}` : getDatasetLabel(dataset.label)
      })
      chart.getChartObject().options.plugins.stacked100 = { enable: true, replaceTooltipLabel: false }
      if (_this.modeValue === 'grouped') {
        configureGroupStackDataLabels(_this, chart)
      } else {
        configureDataLabels(_this, chart)
      }

      chart.getChartObject().options.plugins.legend.display = false
      chart.getChartObject().update()
      chartConfig.options.onClick = (event, native, active) => { 
        clickToOpenURL(chart, native, _linkTarget)
      }
    }, 1);
    
  } 
}